import {
  AccountRoleKey,
  ERole,
} from '@/types';

export const showAccountTenantSelect = (role: AccountRoleKey | undefined) => [
  ERole.TENANT_MANAGER,
  ERole.TENANT_STAFF,
  ERole.ACQUIRER_MANAGER,
  ERole.ACQUIRER_STAFF,
  ERole.COMPANY_MANAGER,
  ERole.COMPANY_STAFF,
  ERole.SHOP_MANAGER,
  ERole.SHOP_STAFF,
  ERole.VALUE_ISSUER_MANAGER,
  ERole.VALUE_ISSUER_STAFF,
  ERole.WALLET_SERVICE_MANAGER,
  ERole.WALLET_SERVICE_STAFF,
  ERole.GIFT_ISSUER_MANAGER,
  ERole.GIFT_ISSUER_STAFF,
].some((roleCode) => roleCode === role);

export const showAccountAcquirerSelect = (role: AccountRoleKey | undefined) => [
  ERole.ACQUIRER_MANAGER,
  ERole.ACQUIRER_STAFF,
  ERole.COMPANY_MANAGER,
  ERole.COMPANY_STAFF,
  ERole.SHOP_MANAGER,
  ERole.SHOP_STAFF,
].some((roleCode) => roleCode === role);

export const showAccountIssuerSelect = (role: AccountRoleKey | undefined) => [
  ERole.VALUE_ISSUER_MANAGER,
  ERole.VALUE_ISSUER_STAFF,
  ERole.WALLET_SERVICE_MANAGER,
  ERole.WALLET_SERVICE_STAFF,
  ERole.GIFT_ISSUER_MANAGER,
  ERole.GIFT_ISSUER_STAFF,
].some((roleCode) => roleCode === role);

export const showAccountWalletServiceSelect = (role: AccountRoleKey | undefined) => [
  ERole.WALLET_SERVICE_MANAGER,
  ERole.WALLET_SERVICE_STAFF,
  ERole.GIFT_ISSUER_MANAGER,
  ERole.GIFT_ISSUER_STAFF,
].some((roleCode) => roleCode === role);

export const showAccountGiftIssuerSelect = (role: AccountRoleKey | undefined) => [
  ERole.GIFT_ISSUER_MANAGER,
  ERole.GIFT_ISSUER_STAFF,
].some((roleCode) => roleCode === role);
